<template>
  <ul class="list-unstyled">
    <li v-for="book in books" :key="book.id" class="py-2 border-bottom border-primary d-flex">
      <router-link :to="{ name: 'mishna-masechta', params: { slug: book.url_key } }">
        <highlight :msg="book.name" :search="query" effect="highlight"
      /></router-link>
    </li>
  </ul>
</template>
<script>
import HighlightComponent from './Highlight.vue';
export default {
  props: ['books', 'query'],
  components: {
    Highlight: HighlightComponent,
  },
};
</script>
<style>
</style>